import initSwiperSections from "./sections/swiper";

window.initSwiperSections = initSwiperSections;
window.swiperInstances = initSwiperSections();
